export default __webpack_public_path__ + "static/media/Linked_List_Insertion_1.d92ff5a9.gif";